/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssociationUser } from '../models/AssociationUser';
import type { CreateAssociationUserDto } from '../models/CreateAssociationUserDto';
import type { PaginatedDocumented } from '../models/PaginatedDocumented';
import type { UpdateAssociationUserDto } from '../models/UpdateAssociationUserDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AssociationUserService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AssociationUser
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody: CreateAssociationUserDto,
  }): CancelablePromise<AssociationUser> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/association/{associationId}/user',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public findAll({
    page,
    limit,
    filterAssociation,
    filterUserEmail,
    filterAssociationRole,
    filterAssociationGolfClass,
    filterGolfClass,
    filterMembershipStartDate,
    filterMembershipEndDate,
    filterMembershipId,
    sortBy,
    search,
    searchBy,
  }: {
    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     * <p>
     * <b>Example: </b> 1
     * </p>
     * <p>
     * <b>Default Value: </b> 1
     * </p>
     *
     */
    page?: number,
    /**
     * Number of records per page.
     * <p>
     * <b>Example: </b> 20
     * </p>
     * <p>
     * <b>Default Value: </b> 20
     * </p>
     * <p>
     * <b>Max Value: </b> 100
     * </p>
     *
     * If provided value is greater than max value, max value will be applied.
     *
     */
    limit?: number,
    /**
     * Filter by association query param.
     * <p>
     * <b>Format: </b> filter.association={$not}:OPERATION:VALUE
     * </p>
     * <p>
     * <b>Example: </b> filter.association=$not:$like:John Doe&filter.association=like:John
     * </p>
     * <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
    filterAssociation?: Array<string>,
    /**
     * Filter by user.email query param.
     * <p>
     * <b>Format: </b> filter.user.email={$not}:OPERATION:VALUE
     * </p>
     * <p>
     * <b>Example: </b> filter.user.email=$not:$like:John Doe&filter.user.email=like:John
     * </p>
     * <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
    filterUserEmail?: Array<string>,
    /**
     * Filter by associationRole query param.
     * <p>
     * <b>Format: </b> filter.associationRole={$not}:OPERATION:VALUE
     * </p>
     * <p>
     * <b>Example: </b> filter.associationRole=$not:$like:John Doe&filter.associationRole=like:John
     * </p>
     * <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
    filterAssociationRole?: Array<string>,
    /**
     * Filter by associationGolfClass query param.
     * <p>
     * <b>Format: </b> filter.associationGolfClass={$not}:OPERATION:VALUE
     * </p>
     * <p>
     * <b>Example: </b> filter.associationGolfClass=$not:$like:John Doe&filter.associationGolfClass=like:John
     * </p>
     * <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
    filterAssociationGolfClass?: Array<string>,
    /**
     * Filter by golfClass query param.
     * <p>
     * <b>Format: </b> filter.golfClass={$not}:OPERATION:VALUE
     * </p>
     * <p>
     * <b>Example: </b> filter.golfClass=$not:$like:John Doe&filter.golfClass=like:John
     * </p>
     * <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
    filterGolfClass?: Array<string>,
    /**
     * Filter by membership.startDate query param.
     * <p>
     * <b>Format: </b> filter.membership.startDate={$not}:OPERATION:VALUE
     * </p>
     * <p>
     * <b>Example: </b> filter.membership.startDate=$not:$like:John Doe&filter.membership.startDate=like:John
     * </p>
     * <h4>Available Operations</h4><ul><li>$gt</li>
     * <li>$gte</li>
     * <li>$lt</li>
     * <li>$lte</li>
     * <li>$null</li>
     * <li>$eq</li></ul>
     */
    filterMembershipStartDate?: Array<string>,
    /**
     * Filter by membership.endDate query param.
     * <p>
     * <b>Format: </b> filter.membership.endDate={$not}:OPERATION:VALUE
     * </p>
     * <p>
     * <b>Example: </b> filter.membership.endDate=$not:$like:John Doe&filter.membership.endDate=like:John
     * </p>
     * <h4>Available Operations</h4><ul><li>$gt</li>
     * <li>$lt</li>
     * <li>$gte</li>
     * <li>$lte</li>
     * <li>$null</li>
     * <li>$eq</li></ul>
     */
    filterMembershipEndDate?: Array<string>,
    /**
     * Filter by membership.id query param.
     * <p>
     * <b>Format: </b> filter.membership.id={$not}:OPERATION:VALUE
     * </p>
     * <p>
     * <b>Example: </b> filter.membership.id=$not:$like:John Doe&filter.membership.id=like:John
     * </p>
     * <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$not</li>
     * <li>$null</li></ul>
     */
    filterMembershipId?: Array<string>,
    /**
     * Parameter to sort by.
     * <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     * <p>
     * <b>Format: </b> fieldName:DIRECTION
     * </p>
     * <p>
     * <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     * </p>
     * <p>
     * <b>Default Value: </b> id:DESC
     * </p>
     * <h4>Available Fields</h4><ul><li>id</li>
     * <li>user.email</li>
     * <li>user.firstName</li>
     * <li>user.lastName</li>
     * <li>associationRole.name</li></ul>
     *
     */
    sortBy?: Array<'id:ASC' | 'id:DESC' | 'user.email:ASC' | 'user.email:DESC' | 'user.firstName:ASC' | 'user.firstName:DESC' | 'user.lastName:ASC' | 'user.lastName:DESC' | 'associationRole.name:ASC' | 'associationRole.name:DESC'>,
    /**
     * Search term to filter result values
     * <p>
     * <b>Example: </b> John
     * </p>
     * <p>
     * <b>Default Value: </b> No default value
     * </p>
     *
     */
    search?: string,
    /**
     * List of fields to search by term to filter result values
     * <p>
     * <b>Example: </b> user.email,user.firstName,user.lastName
     * </p>
     * <p>
     * <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     * </p>
     * <h4>Available Fields</h4><ul><li>user.email</li>
     * <li>user.firstName</li>
     * <li>user.lastName</li></ul>
     *
     */
    searchBy?: Array<string>,
  }): CancelablePromise<PaginatedDocumented> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/association/{associationId}/user',
      query: {
        'page': page,
        'limit': limit,
        'filter.association': filterAssociation,
        'filter.user.email': filterUserEmail,
        'filter.associationRole': filterAssociationRole,
        'filter.associationGolfClass': filterAssociationGolfClass,
        'filter.golfClass': filterGolfClass,
        'filter.membership.startDate': filterMembershipStartDate,
        'filter.membership.endDate': filterMembershipEndDate,
        'filter.membership.id': filterMembershipId,
        'sortBy': sortBy,
        'search': search,
        'searchBy': searchBy,
      },
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public updateById({
    id,
    requestBody,
    relations,
  }: {
    id: number,
    requestBody: UpdateAssociationUserDto,
    relations?: Array<string>,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/v1/association/{associationId}/user/{id}',
      path: {
        'id': id,
        'relations': relations,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns AssociationUser
   * @throws ApiError
   */
  public getOne({
    id,
    relations,
  }: {
    id: number,
    relations?: Array<string>,
  }): CancelablePromise<AssociationUser> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/association/{associationId}/user/{id}',
      path: {
        'id': id,
        'relations': relations,
      },
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public deleteById({
    id,
    relations,
  }: {
    id: number,
    relations?: Array<string>,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/v1/association/{associationId}/user/{id}',
      path: {
        'id': id,
        'relations': relations,
      },
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public countUsers(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/association/{associationId}/user/aggregate/count',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public updateEmail({
    id,
    relations,
  }: {
    id: number,
    relations?: Array<string>,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/association/{associationId}/user/{id}/email',
      path: {
        'id': id,
        'relations': relations,
      },
    });
  }
}
